module.exports = __webpack_public_path__ + "img/step-15.684b5137.jpg";